"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var models_1 = require("../../../models");
var locale_es_1 = __importDefault(require("../../../translations/locale-es"));
var optionCampaignFilterList = [
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.PENDING_UPLOAD_FILE_OF_CLIENTS],
        dbKey: models_1.EnumCampaignStatus.PENDING_UPLOAD_FILE_OF_CLIENTS,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS],
        dbKey: models_1.EnumCampaignStatus.IN_PROGRESS_UPLOAD_FILE_OF_CLIENTS,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.FAIL_PROCESSING_CLIENTS],
        dbKey: models_1.EnumCampaignStatus.FAIL_PROCESSING_CLIENTS,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD],
        dbKey: models_1.EnumCampaignStatus.IN_PROGRESS_ASSIGN_CARD,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD],
        dbKey: models_1.EnumCampaignStatus.PENDING_ASSIGN_CARD,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS],
        dbKey: models_1.EnumCampaignStatus.SUCCESS_ASSIGNED_CARDS,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS],
        dbKey: models_1.EnumCampaignStatus.FAIL_ASSIGNED_CARDS,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES],
        dbKey: models_1.EnumCampaignStatus.PENDING_RECHARGE_BALANCES,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.PENDING_SEND_EMAIL],
        dbKey: models_1.EnumCampaignStatus.PENDING_SEND_EMAIL,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.PROCESS_SEND_EMAIL],
        dbKey: models_1.EnumCampaignStatus.PROCESS_SEND_EMAIL,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.FAIL_PROCESS_SEND_EMAIL],
        dbKey: models_1.EnumCampaignStatus.FAIL_PROCESS_SEND_EMAIL,
    },
    {
        filter: 'Estado',
        key: 'status',
        value: locale_es_1.default['status'][models_1.EnumCampaignStatus.SENT_EMAIL_ACTIVATION],
        dbKey: models_1.EnumCampaignStatus.SENT_EMAIL_ACTIVATION,
    },
];
exports.default = optionCampaignFilterList;
